<template>
  <div class="container-fluid">
    <div class="contents membership bucks">
      <tab />

      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-1"
          role="tabpanel"
          aria-labelledby="pills-1-tab"
        >
          <!--      <div class="d-flex justify-content-end filter-box gap-1">
            <div class="search-input flex-grow-1">
              <input
                type="text"
                class="form-control-lg pe-5 ph-14"
                placeholder="닉네임으로 검색"
                v-model="searchData.searchtext"
              />
              <input
                class="btn btn-primary btn-lg icon-search"
                type="button"
                value=""
                @click="search"
              />
            </div>
            <div>
              <button
                class="btn btn-primary btn-lg btn-refresh"
                type="button"
                @click="refresh"
              >
                <span class="m-none d-inline lh-48">초기화 </span
                ><i class="material-icons">refresh</i>
              </button>
            </div>
          </div> -->

          <b-form>
            <div class="row row-cols-2 row-cols-lg-4 g-2 mb-4">
              <div class="col-12 col-sm-6">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('title.common.nickname')"
                    :aria-label="$t('title.common.nickname')"
                    v-model="searchData.searchtext"
                  />
                  <button
                    class="btn btn-primary btn-lg icon-search"
                    type="button"
                    @click="search"
                  ></button>
                  <button
                    class="btn btn-primary btn-refresh ms-2"
                    type="button"
                    @click="refresh"
                  >
                    <!-- <span class="m-none d-inline lh-48 ms-1">초기화</span> -->
                    <i class="material-icons">refresh</i>
                  </button>
                </div>
              </div>
            </div>
          </b-form>
          <div class="paging-box">
            <div v-if="ballance_yn === true" class="lh-sm">
              <!--{{ playerPoint.nickname }}-->
              {{ $t("title.membership.availablebalance") }}
              <span class="fw-bold point"
                >{{ playerPoint.sum_points | comma }}B</span
              >
            </div>
            <div class="ms-auto">
              <!-- p>페이징수</p -->
              <select
                class="sort"
                v-model="searchData.pagesize"
                @change="init(1)"
              >
                <option value="10">{{ $t("filter.common.10perpage") }}</option>
                <option value="20">{{ $t("filter.common.20perpage") }}</option>
                <option value="30">{{ $t("filter.common.30perpage") }}</option>
                <option value="40">{{ $t("filter.common.40perpage") }}</option>
                <option value="50">{{ $t("filter.common.50perpage") }}</option>
                <option value="60">{{ $t("filter.common.60perpage") }}</option>
                <option value="70">{{ $t("filter.common.70perpage") }}</option>
                <option value="80">{{ $t("filter.common.80perpage") }}</option>
                <option value="90">{{ $t("filter.common.90perpage") }}</option>
                <option value="100">
                  {{ $t("filter.common.100perpage") }}e
                </option>
              </select>
            </div>
          </div>
          <table class="table board" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.number") }}
                </th>
                <th class="col-auto">{{ $t("title.common.nickname") }}</th>
                <th class="col-auto">{{ $t("title.common.bucks") }}</th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.comment") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.date") }}
                </th>
                <th class="col-1">
                  <input
                    type="checkbox"
                    v-model="allSelected"
                    @click="selectAll()"
                  />
                </th>
                <th class="th-arrow">&nbsp;</th>
              </tr>
            </thead>
            <tbody v-if="pointListCnt">
              <template v-for="(item, index) in pointList">
                <tr class="btn1" @click="toggle_tr(index)" :key="index">
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.no }}
                  </td>
                  <td
                    class="col-auto more pointer"
                    @click="
                      searchData.searchtext = item.nickname;
                      searchclick();
                    "
                  >
                    {{ item.nickname }}
                  </td>
                  <td class="col-auto d-lg-table-cell color-cyan">
                    {{ item.points | comma }}B
                  </td>
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.description }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell date">
                    {{ item.timezoee_regdate | dateformat }}
                  </td>
                  <td class="col-1 d-lg-table-cell">
                    <input
                      type="checkbox"
                      class="form-check-input custom-checkbox"
                      :value="index"
                      v-model="checkedPointidx"
                      @change="updateCheckall()"
                    />
                  </td>
                  <td class="td-arrow end">
                    <img
                      src="/img/arrow_none_collapsed.png"
                      :class="{ 'btn-toggle-arrow': view_hide === index }"
                    />
                  </td>
                </tr>
                <tr
                  class="col-auto d-lg-none d-md-tabel-cell"
                  :class="{ show: view_hide === index }"
                  :key="index + 'r'"
                  v-if="view_hide === index"
                >
                  <td class="align-left" colspan="6">
                    <div class="layer1">
                      <div class="row">
                        <div class="col-6">{{ $t("title.common.number") }}</div>
                        <div class="col-6">{{ item.no }}</div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          {{ $t("http://title.common.id") }}
                        </div>
                        <div class="col-6">{{ item.player_id }}</div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          {{ $t("title.common.comment") }}
                        </div>
                        <div class="col-6">{{ item.description }}</div>
                      </div>
                      <div class="row">
                        <div class="col-6">{{ $t("title.common.date") }}</div>
                        <div class="col-6">
                          {{ item.timezoee_regdate | dateformat }}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
          <b-pagination-nav
            :link-gen="linkGen"
            :number-of-pages="page_total"
            v-model="searchData.pageno"
            use-router
            aria-label="Page navigation example"
            v-if="page_total > 1"
            first-class="prev"
            prev-class="prev"
            next-class="next"
            last-class="next"
            hide-ellipsis
            limit="10"
          >
            <template #first-text
              ><i class="material-icons"
                >keyboard_double_arrow_left</i
              ></template
            >
            <template #prev-text
              ><i class="material-icons">navigate_before</i></template
            >
            <template #next-text
              ><i class="material-icons">navigate_next</i></template
            >
            <template #last-text
              ><i class="material-icons"
                >keyboard_double_arrow_right</i
              ></template
            >
            <template #page="{ page, active }">
              <a v-if="active">{{ page }}</a>
              <a v-else>{{ page }}</a>
            </template>
          </b-pagination-nav>
          <div class="btn-bottom-wrapper">
            <b-button
              size="xl"
              variant="outline-primary"
              :aria-label="$t('button.bucks_delete')"
              :disabled="!checkedPointidx.length"
              @click="pointDel"
              >{{ $t("button.membership.bucks_delete") }}</b-button
            >
            <b-button
              size="xl"
              variant="primary"
              :aria-label="$t('button.bucks_add')"
              :disabled="!ballance_yn"
              @click="
                $refs['modal-email'].modalOuterStyle.zIndex = 9999;
                $refs['modal-email'].show();
              "
              >{{ $t("button.membership.bucks_add") }}</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-email"
      ref="modal-email"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">{{ $t("page.membership.add_bucks") }}</h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="close()"
        ></b-button>
      </template>
      <div class="border-top-dgray">
        <div class="row g-0 border-bottom">
          <div class="col-sm-3 bg-gray row g-0 align-items-center">
            <label class="d-table-cell">{{
              $t("title.common.nickname")
            }}</label>
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              class="form-control-lg"
              v-model="sendData.playerNickname"
            />
          </div>
        </div>
        <div class="row g-0 border-bottom">
          <div class="col-sm-3 bg-gray row g-0 align-items-center">
            <label class="d-table-cell">{{ $t("title.common.bucks") }}</label>
          </div>
          <div class="col-sm-9">
            <input
              type="number"
              class="form-control-lg point"
              v-model="sendData.addPoint"
            />
          </div>
        </div>
        <div class="row g-0 border-bottom">
          <div class="col-sm-3 bg-gray row g-0 align-items-center">
            <label class="d-table-cell">{{ $t("title.common.comment") }}</label>
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              class="form-control-lg"
              v-model="sendData.content"
            />
          </div>
        </div>
      </div>
      <template #modal-footer="{}">
        <b-button
          size="md"
          variant="outline-secondary"
          aria-label="cancel"
          @click="
            $bvModal.hide('modal-email');
            sendData.addPoint = 0;
            sendData.content = '';
          "
          >{{ $t("button.common.cancel") }}</b-button
        >
        <b-button
          size="md"
          variant="secondary"
          aria-label="add"
          @click="pointAdd"
          >{{ $t("button.common.add") }}</b-button
        >
      </template>
      <!--       <template #modal-footer="{}">
        <div class="col-6 col-sm-3">
          <button
            class="btn btn-primary btn-md w-100"
            type="button"
            @click="pointAdd"
          >
            추가
          </button>
        </div>
        <div class="col-6 col-sm-3">
          <button
            class="btn btn-outline-secondary btn-md w-100"
            type="button"
            aria-label="Close"
            @click="
              $bvModal.hide('modal-email');
              sendData.addPoint = 0;
              sendData.content = '';
            "
          >
            취소
          </button>
        </div>
      </template> -->
    </b-modal>
  </div>
</template>

<script>
import commonDataTable from "@/components/common/table/DataTable";
import commonDatePicker from "@/components/common/datepicker/Picker";
import "@/filter/common";
import ax from "@/api/member";
import axSetting from "@/api/setting";
import tab from "@/components/member/Tab";

export default {
  name: "PointAdmin",
  components: {
    commonDataTable,
    tab,
  },
  data() {
    return {
      pointList: [],
      checkedPointidx: [],
      allSelected: false,
      searchData: {
        searchtext:
          this.$route.query.searchtext ||
          this.$store.state.searchData.searchtext ||
          "",
        pageno:
          this.$route.query.pageno || this.$store.state.searchData.pageno || 1,
        pagesize:
          this.$route.query.pagesize ||
          this.$store.state.searchData.pagesize ||
          10,
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      sendData: {
        content: "",
        playerNickname: "",
        addPoint: 0,
        checkedPointItem: [],
      },
      ballance_yn: false,
      view_hide: null,
      pointListCnt: 0,
      pointAdd_modal_flag: false,
    };
  },
  watch: {
    "$route.query": function () {
      this.searchData.pageno = parseInt(this.$route.query.page) || 1;
      this.init();
      this.allSelected = false;
      this.checkedPointidx = [];
    },
    searchData: {
      handler: function (val, oldVal) {
        this.$store.commit("setSearchData", val);
      },
      deep: true,
    },
  },
  computed: {},
  created() {
    this.init();
    axSetting.get_owneview((flag, data) => {
      if (flag) {
        this.checkedManagerEmail = data.ownerinfo.email;
      } else {
        alert(data);
      }
    });
  },
  methods: {
    init(pageno) {
      if (pageno) {
        this.searchData.pageno = pageno;
      }
      ax.pointList(this.searchData, (data) => {
        if (data) {
          // console.log(22);
          this.pointList = data.pointlist;
          this.pointListCnt = data.pointlistcnt;

          this.total_cnt = data.pointlistcnt;
          this.page_total = Math.ceil(data.pointlistcnt / this.rows);
          this.playerPoint = data.player_point;
          this.ballance_yn =
            data.pointlistcnt && this.searchData.searchtext ? true : false;
          this.sendData.playerNickname =
            this.ballance_yn && data.player_point.nickname;
          this.sendData.ownerId =
            this.ballance_yn && data.player_point.owner_id;
        } else {
          this.sendData.playerNickname = "";
          this.sendData.ownerId = "";
          this.ballance_yn = false;
          this.pointList = [];
          this.playerPoint = [];
          this.pointListCnt = 0;
          this.page_total = 0;
        }
      });
    },
    selectAll() {
      this.checkedPointidx = [];
      this.sendData.checkedPointItem = [];
      // alert(this.allSelected);
      if (!this.allSelected) {
        for (let i = 0; i < this.pointList.length; i++) {
          //if (this.searchData.pagesize > i) {
          this.checkedPointidx.push(i);
          this.sendData.checkedPointItem.push(
            this.pointList[this.checkedPointidx[i]].record_pk
          );
          //}
        }
      }
    },
    updateCheckall() {
      // this.allSelected = false;
      if (this.pointList.length == this.checkedPointidx.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },
    startDateChange(v) {
      this.params.startdate = v;
    },
    endDateChange(v) {
      this.params.enddate = v;
    },
    search(v) {
      this.init();
    },
    refresh() {
      this.searchData.searchtext = "";
      this.sendData.content = "";
      this.sendData.playerNickname = "";
      this.sendData.addPoint = 0;
      this.sendData.checkedPointItem = [];
      this.allSelected = false;
      this.checkedPointidx = [];

      this.init();
    },
    searchclick() {
      // alert(v);
      this.init();
    },
    pointDel() {
      if (this.checkedPointidx.length < 1) {
        alert(this.$i18n.t("alert.member.select_item"));
      } else {
        if (
          confirm(
            this.$i18n.t("alert.member.checked_be_deleted") +
              "\n" +
              this.$i18n.t("alert.member.want_to_proceed")
          )
        ) {
          this.sendData.checkedPointItem = [];
          for (let i = 0; i < this.checkedPointidx.length; i++) {
            this.sendData.checkedPointItem.push(
              this.pointList[this.checkedPointidx[i]].record_pk
            );
          }

          ax.removePoint(this.sendData, (flag, response) => {
            if (flag) {
              alert(response.message);
              this.checkedPointidx = [];
              this.init();
            } else {
              alert(response.message);
            }
          });
        }
      }
    },
    pointAdd() {
      if (!this.sendData.playerNickname) {
        alert(this.$i18n.t("alert.member.enter_nickname"));
        return false;
      }

      if (this.sendData.addPoint === 0) {
        alert(this.$i18n.t("alert.member.enter_points"));
        return false;
      }

      if (!this.sendData.content) {
        alert(this.$i18n.t("alert.member.enter_content"));
        return false;
      }

      ax.addPoint(this.sendData, (flag, response) => {
        if (flag) {
          alert(response.message);
          // this.sendData.playerNickname = "";
          this.sendData.addPoint = 0;
          this.sendData.content = "";
          this.$refs["modal-email"].hide();
          this.init();
        } else {
          /*this.$notify({
              group: 'alert',
              type: 'info',
              title: '정보',
              text: '발송에 실패하였습니다.'
            })*/
          alert(response.message);
        }
      });
    },
    linkGen(pageNum) {
      return pageNum === 1
        ? `?searchtext=${this.searchData.searchtext}`
        : `?page=${pageNum}&searchtext=${this.searchData.searchtext}`;
    },
    excelSave() {
      ax.excelSave(this.searchData, (filename, body) => {
        let tab_text =
          '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
        tab_text +=
          '<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
        tab_text +=
          "<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
        tab_text += "<x:Name>Test Sheet</x:Name>";
        tab_text +=
          "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
        tab_text += "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
        tab_text += "<table>";
        tab_text += body;
        tab_text += "</table></body></html>";
        const fileName = filename;
        const a_tag = document.createElement("a");
        const blob = new Blob([tab_text], {
          type: "application/vnd.ms-excel;charset=utf-8;",
        });
        a_tag.href = window.URL.createObjectURL(blob);
        a_tag.download = fileName;
        a_tag.click();
      });
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>

<style>
.page-item.active .page-link {
  z-index: 1 !important;
}
</style>
